<script>
/* Note that this creates / updates an account request and so can be used at the end of an onboard request */
import { mapActions } from 'vuex'
import { getCurrentOnBoardRequest, updateCurrentOnBoardRequest, updateAccountRequest } from '@/onBoardRequest'

export default {
  name: 'GetPIPrimaryAffiliation',
  props: {
    trackName: String,
    orgTree: {
      type: String,
      default: 'Harvard',
    },
    ranks: {
      type: String,
      default: 'department,facility,center,museum,division,institute,school,institution',
    },
    helpEmail: {
      type: String,
      default: 'rchelp@rc.fas.harvard.edu',
    },
  },
  data: function () {
    return {
      stepName: 'pi_affiliation_collected',
      loading: false,
      isValid: false,
      onBoardRequest: {},
      organizations: [],
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    onFocus() {
      this.$refs.orgSelect.isMenuActive = true
    },
    resetForm() {
      this.$refs.primaryAffiliationForm.reset()
    },
    submit() {
      const me = this

      this.onBoardRequest.setTrackStepComplete(this.trackName, this.stepName)
      updateCurrentOnBoardRequest(me.onBoardRequest)
        .then((res) => {
          me.onBoardRequest = res
          updateAccountRequest(me.onBoardRequest)
            .then((res2) => {
              this.$api.mountNextComponent(res2)
            })
            .catch((err) => {
              me.showMessage(err)
            })
        })
        .catch((err) => {
          me.showMessage(err)
        })
    },
  },
  computed: {
    searchPlaceholder: function () {
      const base = 'Begin typing your affiliation name'
      return this.loading ? `${base} (loading)` : base
    },
  },
  mounted: function () {
    const me = this
    this.loading = true

    this.$api
      .getOrgNames(this.orgTree, null, this.ranks)
      .then((res) => {
        me.organizations = res.data
        getCurrentOnBoardRequest()
          .then((res2) => {
            me.onBoardRequest = res2
            me.$nextTick(() => me.$refs.orgSelect.focus())
          })
          .catch((err) => me.showMessage(err))
      })
      .catch((err) => me.showMessage(err))
      .finally((me.loading = false))
  },
}
</script>
<template>
  <v-layout align-center justify-space-between row fill-height>
    <v-flex class="lg-inner">
      <h1>What is your primary affiliation?</h1>
      <p>Select the department, institute, etc. with which you are primarily affiliated.</p>
      <p>
        If you cannot find an appropriate affiliation, please
        <a :href="`mailto:${helpEmail}`">send in a ticket.</a>
      </p>
      <v-form id="primary-affiliation-form" ref="primaryAffiliationForm" v-model="isValid" @submit.prevent="submit">
        <v-flex>
          <v-combobox
            :items="organizations"
            key="organization-list"
            ref="orgSelect"
            autocomplete="new-password"
            :placeholder="searchPlaceholder"
            item-text="name"
            item-value="slug"
            prepend-icon="search"
            :loading="loading"
            hide-no-data
            :rules="[(v) => !!v || 'Affiliation is required.']"
            v-model="onBoardRequest.primaryAffiliation"
            :return-object="false"
          ></v-combobox>
        </v-flex>
        <v-layout row justify-end>
          <v-btn @click.prevent="submit" role="button" class="btn" color="secondary" :disabled="!isValid">Submit</v-btn>
        </v-layout>
      </v-form>
    </v-flex>
  </v-layout>
</template>
<style lang="css" scoped>
.text-block {
  margin: 1rem 0;
}
.text-hint {
  margin-top: 2rem;
}
.text-action {
  margin-bottom: 1rem;
}
#primary-affiliation-form {
  margin-top: 1rem;
}
.pi-admin-field {
  margin: 1rem 0;
}
</style>
